import script from "./GravatarMixin.vue?vue&type=script&lang=js"
export * from "./GravatarMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__